// extracted by mini-css-extract-plugin
module.exports = {"footerLink":"MobileFooterLink_footerLink__3Bwsr","icon":"MobileFooterLink_icon__3QJKn","leftContent":"MobileFooterLink_leftContent__1hc-L"};